import {ChartOptions} from "chart.js";
import {FinanceDashboardPieChartOptions} from "./finance-dashboard-chart-options";

export const InsightQueriesPieChartOptions: ChartOptions = {
  ...FinanceDashboardPieChartOptions,
  plugins: {
    ...FinanceDashboardPieChartOptions.plugins,
  },
};

export const InsightQueriesPieChartNoLegendOptions: ChartOptions = {
  ...InsightQueriesPieChartOptions,
  plugins: {
    ...InsightQueriesPieChartOptions.plugins,
    legend: {display: false},
    datalabels: {
      ...(InsightQueriesPieChartOptions.plugins?.datalabels ?? {}),
      clip: false,
      offset: 10,
      anchor: 'end',
      align: 'end',
    }
  },
  layout: {
    padding: {
      top: 16,
      bottom: 50,
      left: 30,
      right: 30
    }
  }
};
